import { ChangeDetectorRef, Directive, EventEmitter, Input, NgZone, OnInit, Output } from '@angular/core';
import { CommonController } from '@common/classes/common.controller';
import { ModalService } from '@common/services/modal.service';
import { TranslateService } from '@ngx-translate/core';

@Directive()
export class BasePrintComponent extends CommonController implements OnInit {
    @Input() model: any;
    @Input() now: Date;
    @Output() logoLoaded = new EventEmitter<void>();

    logoUrl: string;
    isViewInitialized = false;

    constructor(
        dialogService: ModalService,
        translateService: TranslateService,
        protected cdr: ChangeDetectorRef,
        protected ngZone: NgZone
    ) {
        super(dialogService, translateService);
    }

    ngOnInit(): void {
        if (document.readyState === 'complete') {
            this.loadLogoAsBase64();
        } else {
            window.addEventListener('load', () => {
                this.loadLogoAsBase64();
            });
        }
    }

    private loadLogoAsBase64(): void {
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.onload = () => {
            this.ngZone.run(() => {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                this.logoUrl = canvas.toDataURL('image/jpeg');
                this.isViewInitialized = true;
                this.cdr.detectChanges();
                // Emit event to notify parent that logo is ready
                setTimeout(() => this.logoLoaded.emit(), 0);
            });
        };
        img.onerror = () => {
            this.ngZone.run(() => {
                console.error('Failed to load logo image');
                this.isViewInitialized = true;
                this.cdr.detectChanges();
                // Emit event even on error so PDF generation can proceed
                setTimeout(() => this.logoLoaded.emit(), 0);
            });
        };
        img.src = `${window.location.origin}/assets/img/Bulgarian-Port_logo.jpg`;
    }
}
